export const TRIM_UNDERSCORE_REGEX = new RegExp(/^_+|_+$/g);
